export function kebabCase(string) {
    return string
        .replace(/[A-Z]/g, function(match) {
            return '-' + match.toLowerCase()
        })
        .replace(/_/g, '-')
}
